const text = 
{
    "Test":"The text which should show here@!!!!",
    "Login:view:username":"BANANA",
    "CredentialDetailsCombo:view:username":"Benutzer details",
    "CredentialDetailsCombo:view:cardid":"Benutzer editieren",
    "Admin":"Administrator",
    "Created":"Erstelldatum",
    "CreatedBy":"Ersteller",
    "Action":"Aktion",
    "Yes":"Ja",
    "No":"Nein",
    "IP":"IP",
    'Hostname':'Hostname',
    "Name":"Name",
    "WatchdogRange":"Überwachungsbereich",
    "AddPlayground":"Überwachungsbereich hinzufügen",
    "Heavy Scan":"Intensiver Scan",
    "Tag":"Tag",
    "tags":"Tags",
	"Actions":"Aktionen",
	"Role":"Rolle",
    "Options":"Optionen",
    "Progress":"Fortschritt",
    "Target":"Ziel",
    "AddScan":"Scan hinzufügen",
    "Delete":"Löschen",
    "days":"Tage",
    "hours":"Stunden",
    "Scanjobs":"Scanjobs",
    "Description":"Beschreibung",
    "Active":"Aktiv",
    "Config":"Config",
    "Setup":"Setup",
    "Parallel":"Parallel",
    "Tags":"Tags",
    "Depends":"Abhängigkeit",
    "Rule":"Regel",
    "Notification":"Infos",
    "Language":"EN",
    "Contact":"Kontakt",
    "Customer":"Kunde",
    "Submit":"Absenden",
    "FullName":"Ganzer Name",
    "Details":"Details",
    "Login":"Einloggen",
    "Dashboard":"Übersicht",
    "Vulnerabilities":"Schwachstellen",
    "Ziele":"Ziele" ,   
    "NetzwerkScan":"Netzwerk-scan",
    "Watchdog":"Watchdog",
    "Alle Vulnerabilites":"Alle Schwachstellen",
    "Alle Reports":"Alle Berichte",
    "Netzwerkuebersicht":"Netzwerkübersicht ",
    "User":"Benutzer",
    "Administratoren":"Administratoren",
    "Targets":"Ziele",
    "Scans":"Scans",
    "Updated":"Updated",
    "Scannerstatus":"Scannerstatus",
    "Ping":"Ping",
    "Nodedistance":"Netzknoten",
    "LastScan":"Letzter Scan ",
    "NextScan":"Nächster Scan",
    "LowSeverity":"Niedriges Risiko",
    "MediumSeverity":"Mittleres Risiko",
    "HighSeverity":"Hohes Risiko",
    "Report":"Bericht",
    "Issue":"Problem",
    "Version":"Version",
    "OSVersion":"OS Version",
    "accuracy":"Genauigkeit",
    "TargetInformation":"Ziel-Information",
    "Software":"Software",
    "AdditionalInformation":"Additional-Information",
    "SoftwareName":"Softwarename",
    "TopVulnerabilities":"Top Schwachstellen",
    "Severity":"Risiko",
    "Type":"Type",
    "ActiveTargetlist":"Aktive Zielliste",
    "Attention":"Achtung",
    "ModifyTarget":"Speichere Änderungen",
    "Groupname":"Gruppenname",
    "Message":"Nachricht",
    "FinishedScan":"Beendeter Scan",
    "Severity1-5":"Klassifizierung 1-5",
    "Severity5-7":"Klassifizierung 5-7",
    "Severity7-10":"Klassifizierung 7-10",
    "Credentials":"Zugangsdaten",
    "Scan Rule":"Regelwerk",
    "Mandanten":"Mandanten",
    "CompanyName":"Name des Unternehmen",
    "CustomerName":"Kunden Name",
    "CustomerPhone":"Kunden Telefon",
    "CustomerMail":"Kunden E-Mail",
    "Title":"Titel",
    "Lastname":"Nachname",
	"Username":"Benutzername",
    "Phone":"Telefonnummer",
    "NumberOfTargets":"Anzahl an Zielen",
    "TargetTolerance":"Toleranz Zielzahl (%)",
    "HubDefault":"Vorgabe",
    "SaveTargetTolerance":"Toleranz speichern",
    "Modules":"Module",
    "Generate License":"Erstelle Lizenz",
    "License":"Lizenz",
    "Mail":"E-Mail",
    "Street":"straße",
    "Postcode":"Postleitzahl",
    "City":"Stadt",
    "Country":"Land",
    "127.0.0.1":"127.0.0.1",
    "RuleName":"Regel",
    "Avatar":"Avatar",
	"keyphrase":"Schlüssel",
	"passphrase":"Passphrase",
	"publicPGPkey":"Öffentl. PGP-Schluessel",
	"SNMPCOMMUNITY":"SNMP Community",
    "Deactivate":"Deaktivieren",
    "Activate":"Aktivieren",
    "Userlist":"Benutzerliste",
    "E-Mail":"E-Mail",
    "Count":"Anzahl",
    "Sev.":"Sev.", 
    "ActiveRanges":"Aktive Bereiche",
    "Createuser":"Neuen Benutzer erstellen",
	"Password":"Passwort",
    "Passwordrepeat":"Passwordwiederholung",
    "Gender":"Geschlecht",
    "CreateUser":"Benutzer erstellen",
    "Male":"Männlich",
    "Female":"Weiblich",
    "Other":"Divers",
	"Port":"Port",
    "CredentialsGroup":"Zugangsdatengruppe",
    "fieldrequired":"Notwendige Eingabe",
    "CredGrpinput:cardtitle":"Neue Logindaten erstellen",
    "CredGrpinput:namelabel":"Gruppenname",
    "CredGrpinput:creat group button":"Zugangsdatengruppe erstellen",
    "CredInput:option1":"Benutzername + Passwort",
    "CredInput:option2":"Benutzername und SSHKey",
    "CredInput:option3":"Zertifikat",
    "CredInput:option4":"PGP Verschlüsselung",
    "CredInput:option5":"Nur Passwort",
    "CredInput:LabelCredGroup":"Zugangsdatengruppe",
    "CredInput:LabelAllow_insecurity":"Unsichere Verbindung erlauben",
    "CredInput:LabelUsername":"Benutzername",
    "CredInput:LabelPassword":"Passwort",
    "CredInput:LabelAuthentic-Algo":"Autentifizierungs-Algorithmus",
    "CredInput:LabelPriv-Algo":"Verschlüsselungs-Algorithmus",
    "None":"Leer",
    "footer:rights":"Alle Rechte vorbehalten",
    "CredInput:CreateCred":"Zugangsdaten erstellen",
    "CredTab:TitleCredGroups":"Zugangsdatengruppen",
    "Error:404text":"Ein Fehler ist aufgetreten",
    "Error:404":"zurück",
    "Error:500text":"Diese Seite existiert nicht",
    "Error:500":"zurück",
    "login:view:Username":"Benutzername",
    "login:view:Password":"Passwort",
    "Logout":"Ausloggen",
    "Issues":"Probleme",
    "LogTable:TitleCol1LogType":"Log Type",
    "LogTable:TitleCol2Title":"Titel",
    "LogTable:TitleCol3message":"Nachricht",
    "MandantenInput:CardTitle":"Kunden anlegen",
    "MandantenInput:LabelClient":"Mandant",
    "MandantenInput:LabelCustomer":"Kunden Information",
    "MandantenInput:LabelContact":"Kontankt Information",
    "MandantenInput:LabelCreateClient":"Kunden anlegen",
    "MandantenTable:TitleCol1Name":"Name",
    "MandantenTable:TitleCol2Contact":"Ansprechpatner",
    "MandantenTable:TitleCol3Customer":"Kunde",
    "MandantenTable:CardTitle":"Kundenliste",
    "GraphThingyTable:CardTitle":"Benutzerliste",
    "MyInputThingy:Username":"Benutzername",
    "MyInputThingy:Password":"Passwort",
    "MyTableThingy:Name":"Name",
    "MyTableThingy:Age":"Alter",
    "MyTableThingy:Adress":"Addresse",
    "MyTableThingy:Userlist":"Benutzerliste",
    "NetworkScanActive:TitleCol1":"Netzbereich",
    "NetworkScanActive:TitleCol2Status":"Status",
    "NetworkScanActive:TitleCol3Action":"Aktion",
    "NetworkScanActive:Delete":"Löschen",
    "NetworkScanActive:ActiveNetworkScan":"Warteschlange",
    "NetworkScanInput:DetecionScan":"Netzwerksuche",
    "NetworkScanInput:NetworkRange":"Netzbereich",
    "NetworkScanTable:NoScanDefined":" Kein Scanprofil ausgewählt",
    "NetworkScanTable:willbescanned":" wird gescannt ",
    "NetworkScanTable:willbedeleted":" wird gelöscht ",
    "NetworkScanTable:clicktocancel":"Zum anhalten klicken",
    "Network:suretodelete":"Bist du sicher, dass du diese Aufgabe löschen willst?",
    "Network:netowrkscan":"Netzwerk-scan",
    "Network:networkscanrevealed":"Netzwerk-scan ergab: ",
    "Network:networkscanactivedevices":" aktive Netzpunkte",
    "NetworkTable:TitleCol1":"Addresse",
    "NetworkTable:TitleCol2Age":"Alter",
    "NetworkTable:TitleCol3Address":"Addresse",
    "NetworkTable:Cardtitle":"Netzwerktabelle",
    "NetworkGraph:Title":"Netzwerkgraph",
    "ReportTable:Identifier":"Identifikationsnummer",
    "ReportTable:Reporttype":"Berichtsart",
    "ReportTable:Reporttitle":"Berichtsübersicht",
    "ScanConfigInput:Title":"Scan Konfigurator",
    "ScanConfigInput:Starttime":"Startzeit",
    "ScanDetailsCombo:ScanDetails":"Scan Details",
    "ScanRuleDetails:TasksIncluded":"Eingebundene Aufgaben",
    "ScanRuleInput:CreateNewRule":"Erstelle neue Scan-regel",
    "ScanRuleInput:CreateNew":"Erstelle neue Scan-regel",
    "ScanRule:CardTitle":"Regelwerk",
    "TargetDetails:TDFor":"Detailansicht für ",
    "Processing":"Verarbeite",
    "Waiting":"Wartet",
    "WatchdogModifier":"Watchdog Modifizierer",
    "AddInfo":"Additional Information",
    "OsInfo":"OS Information",
    "ForgotPassword":"Passwort vergessen",
    "SendResetKey":"Schlüssel senden",
    "HaveRecoveryKey":"Ich habe einen Schlüssel",
    "VodinDownload:Title":"Vodin herunterladen",
    "VodinDownload:Button":"Vodin {version} ({size})",
    "SetupDownloads:Title":"Downloads des Installationspakets: {total} insgesamt, {lastDays} in den letzten 30 Tagen, {today} heute",
    "SetupDownloads:Empty":"Noch keine Downloads",
    "SetupDownloads:Version":"Fassung",
    "SetupDownloads:Today":"Heute",
    "SetupDownloads:LastDays":"Letzte 30 Tage",
    "SetupDownloads:Total":"Insgesamt",
    "ResetToken":"Reset Token",
    "Login:view:Password":"Password",
    "SideMenu:AuthSettings":"Anmeldung",
    "AuthSettings:AdminOnly":"Diese Seite steht nur Administratoren offen.",
    "AuthSettings:LoadFailed":"Die Anmeldeeinstellungen konnten nicht geladen werden.",
    "AuthSettings:Retry":"Erneut versuchen",
    "AuthSettings:MethodsTitle":"Anmeldeverfahren und Reihenfolge",
    "AuthSettings:MethodsHint":"Die Verfahren werden in dieser Reihenfolge geprüft; das erste, das die Anmeldung annimmt, gilt.",
    "AuthSettings:LocalOnly":"Aktiv: nur lokale Anmeldung",
    "AuthSettings:NoLocalWarning":"Die lokale Anmeldung ist entfernt. Danach kann sich nur noch anmelden, wen der Verzeichnisdienst bzw. das SSO annimmt - auch Administratoren. Vorher die Verbindung testen.",
    "AuthSettings:Method:local":"Lokal (Hub-Konten)",
    "AuthSettings:Method:activedirectory":"Active Directory",
    "AuthSettings:Method:ldap":"LDAP",
    "AuthSettings:Method:keycloak":"Keycloak (OIDC)",
    "AuthSettings:Up":"Nach oben",
    "AuthSettings:Down":"Nach unten",
    "AuthSettings:Remove":"Entfernen",
    "AuthSettings:Add":"Hinzufügen:",
    "AuthSettings:Active":"aktiv",
    "AuthSettings:Inactive":"nicht aktiv",
    "AuthSettings:LdapTitle":"LDAP / Active Directory",
    "AuthSettings:Ldap:Server":"Server",
    "AuthSettings:Ldap:Port":"Port",
    "AuthSettings:Ldap:PortHint":"AD Global Catalog 3268, LDAP 389; leer = Standard",
    "AuthSettings:Ldap:BaseDn":"Base DN",
    "AuthSettings:Ldap:BindDn":"Bind DN",
    "AuthSettings:Ldap:BindPassword":"Bind-Passwort",
    "AuthSettings:Ldap:UserAttribute":"Benutzerattribut",
    "AuthSettings:Ldap:UserAttributeHint":"AD sAMAccountName, LDAP uid; leer = Standard",
    "AuthSettings:Ldap:Group":"Erforderliche Gruppe",
    "AuthSettings:Ldap:GroupHint":"Nur Mitglieder dieser Gruppe dürfen sich anmelden; leer = jeder im Base DN",
    "AuthSettings:KeycloakTitle":"Keycloak / OIDC",
    "AuthSettings:Keycloak:Url":"URL",
    "AuthSettings:Keycloak:Realm":"Realm",
    "AuthSettings:Keycloak:ClientId":"Client ID",
    "AuthSettings:Keycloak:ClientSecret":"Client Secret",
    "AuthSettings:Keycloak:Role":"Erforderliche Rolle",
    "AuthSettings:Keycloak:RoleHint":"Nur Konten mit dieser Rolle dürfen sich anmelden; leer = jedes Konto im Realm",
    "AuthSettings:Keycloak:RedirectUri":"Redirect URI",
    "AuthSettings:Keycloak:Scope":"Scope",
    "AuthSettings:AutoProvision":"Konten automatisch anlegen",
    "AuthSettings:AutoProvisionHint":"Wer sich erstmals erfolgreich anmeldet, bekommt ein Hub-Konto mit der Rolle unten.",
    "AuthSettings:SecretSet":"gesetzt",
    "AuthSettings:SecretNotSet":"nicht gesetzt",
    "AuthSettings:SecretPlaceholder":"Neuer Wert - leer lassen, um den gespeicherten zu behalten",
    "AuthSettings:SecretHint":"Der gespeicherte Wert wird nie angezeigt, nur ersetzt.",
    "AuthSettings:Test":"Verbindung testen",
    "AuthSettings:TestHint":"Getestet werden die gespeicherten Einstellungen - vorher speichern.",
    "AuthSettings:TestOk":"Verbindung erfolgreich",
    "AuthSettings:TestFailed":"Verbindung fehlgeschlagen",
    "AuthSettings:ProvisionTitle":"Automatisch angelegte Konten",
    "AuthSettings:ProvisionRole":"Rolle",
    "AuthSettings:ProvisionRoleHint":"Gilt für Konten, die LDAP/AD oder Keycloak beim ersten Anmelden anlegen.",
    "AuthSettings:Role:Guest":"Gast",
    "AuthSettings:Role:User":"Benutzer",
    "AuthSettings:Role:Admin":"Administrator",
    "AuthSettings:Save":"Speichern",
    "AuthSettings:Saved":"Anmeldeeinstellungen gespeichert",
    "AuthSettings:SaveRefused":"Der Hub hat die Einstellungen nicht übernommen:",
    "SideMenu:EmergencyUpload":"Notfall-Upload",
    "EmergencyUpload:Title":"Notfall-Upload",
    "EmergencyUpload:Warning":"Der normale Weg ist die Release-Pipeline. Hier hochgeladene Stände sind inaktiv, bis sie unter Updates freigegeben werden.",
    "EmergencyUpload:AdminOnly":"Diese Seite steht nur Administratoren offen.",
    "EmergencyUpload:File":"Paket",
    "EmergencyUpload:ChooseFile":"Datei auswählen",
    "EmergencyUpload:Software":"Software",
    "EmergencyUpload:Version":"Version",
    "EmergencyUpload:Branch":"Zweig",
    "EmergencyUpload:ChooseBranch":"Zweig wählen",
    "EmergencyUpload:ExpectedSha256":"Erwartete SHA-256 (optional)",
    "EmergencyUpload:ExpectedSha256Hint":"Aus der .sha256-Datei des Pakets. Weicht die Summe ab, wird das Paket abgelehnt und beiseitegelegt.",
    "EmergencyUpload:Upload":"Hochladen",
    "EmergencyUpload:Uploading":"Wird hochgeladen …",
    "EmergencyUpload:Refused":"Der Hub hat das Paket abgelehnt (HTTP {status})",
    "EmergencyUpload:Accepted":"Version {version} ({branch}) eingetragen",
    "EmergencyUpload:Inactive":"Der Stand ist inaktiv. Erst nach der Freigabe unter Updates wird er den Spokes angeboten.",
    "EmergencyUpload:Predecessor":"Vorgänger",
    "EmergencyUpload:ToUpdates":"Zu den Updates",
    "EmergencyUpload:Another":"Weiteres Paket",
    "EmergencyUpload:Problem:file-missing":"Bitte eine Datei auswählen.",
    "EmergencyUpload:Problem:file-empty":"Die Datei ist leer.",
    "EmergencyUpload:Problem:file-too-large":"Die Datei ist größer als 1 GiB.",
    "EmergencyUpload:Problem:software-invalid":"Nur Buchstaben, Ziffern, _ und -.",
    "EmergencyUpload:Problem:version-missing":"Bitte die Version angeben, z. B. 7.793.",
    "EmergencyUpload:Problem:version-invalid":"Die Version muss Hauptversion.Nebenversion lauten, z. B. 7.793; jeder Teil höchstens 2147483647.",
    "EmergencyUpload:Problem:branch-missing":"Bitte einen Zweig wählen.",
    "EmergencyUpload:Problem:sha256-invalid":"Eine SHA-256 hat 64 Hexziffern.",
    "EmergencyUpload:Error:version-exists":"Diese Version ist für die Software schon eingetragen.",
    "EmergencyUpload:Error:file-exists":"In der Ablage liegt schon eine Datei dieses Namens.",
    "EmergencyUpload:Error:sha256-mismatch":"Die SHA-256 stimmt nicht. Das Paket wurde nach gluef-abgelehnt verschoben.",
    "EmergencyUpload:Error:package-version-mismatch":"Die Version im Paket (core/VERSION_ID) passt nicht zur angegebenen. Das Paket wurde nach gluef-abgelehnt verschoben.",
    "EmergencyUpload:Error:package-unreadable":"Das ist kein Vodin-Update-Paket (core/VERSION_ID fehlt). Es wurde nach gluef-abgelehnt verschoben.",
    "EmergencyUpload:Error:file-empty":"Die Datei ist leer.",
    "EmergencyUpload:Error:file-too-large":"Das Paket ist größer als 1 GiB.",
    "EmergencyUpload:Error:version-invalid":"Die Version muss Hauptversion.Nebenversion lauten, z. B. 7.793.",
    "EmergencyUpload:Error:version-missing":"Bitte die Version angeben.",
    "EmergencyUpload:Error:branch-invalid":"Unbekannter Zweig.",
    "EmergencyUpload:Error:branch-missing":"Bitte einen Zweig wählen.",
    "EmergencyUpload:Error:upload-aborted":"Die Übertragung brach ab, bevor die Datei vollständig war.",
    "EmergencyUpload:Error:network":"Der Hub war nicht erreichbar oder die Verbindung brach ab.",
    "EmergencyUpload:Error:unauthorized":"Nicht angemeldet oder Sitzung abgelaufen - bitte neu anmelden.",
    "Updates:Archive":"Archivieren",
    "Updates:ArchiveConfirm":"Version {version} archivieren?",
    "Updates:ArchiveHint":"Der Eintrag bleibt erhalten (Spokes auf diesem Stand werden weiter gefunden), das Paket wandert nach gluef-archiv.",
    "Updates:ArchiveSelected":"Ausgewählte archivieren",
    "Updates:ArchiveSelectedConfirm":"{count} Stände archivieren?",
    "Updates:ShowArchived":"Archivierte anzeigen",
    "Updates:ArchivedTag":"archiviert",
    "Updates:Restore":"Wiederherstellen",
    "Updates:Cancel":"Abbrechen",
    "Updates:MustDeactivate":"Erst deaktivieren: Ein aktiver Stand wird nicht archiviert.",
    "Statistic:CpeEntries":"# CPE-Einträge",
    "License:TierUnknown":"unbekannt",
    "License:IncludedInTier":"(in {tier} enthalten)",
    "License:Remove":"Entfernen",
    "License:RemoveConfirm":"Diese Lizenz entfernen?",
    "License:RemoveHint":"Die Lizenz wird archiviert, nicht gelöscht; der Spoke bekommt kein neues Token mehr dafür.",
    "License:Cancel":"Abbrechen",
    "License:Restore":"Wiederherstellen",
    "License:ArchivedTag":"entfernt",
    "License:ShowArchived":"Entfernte anzeigen",
    "License:ForeignKeyTag":"fremder Schlüssel",
    "License:ForeignKeyHint":"Die Anlage prüft diese Lizenz mit einem Lizenzschlüssel, der nicht der dieses Hub ist, läuft also mit Lizenzen, die dieser Hub nicht ausgestellt hat. Der Hub gibt ihr kein Token. Gemeldeter Schlüssel:",
    "License:UnusedTag":"ungenutzt",
    "License:UnusedHint":"Keine Anlage hat die Lizenz übernommen, oder die Anlage hat sich seit längerem nicht gemeldet. Nur ungenutzte Lizenzen lassen sich entfernen.",
    "License:RemoveInUse":"Die Lizenz wird noch genutzt und wurde nicht entfernt.",
    "License:RemoveSelected":"Ausgewählte entfernen ({count})",
    "License:RemoveSeveralConfirm":"{count} Lizenzen entfernen?",
    "License:RemoveSeveralDone":"Entfernt: {archived}, schon entfernt: {unchanged}, abgelehnt: {refused}.",
    "License:RemoveSeveralFailed":"Die Lizenzen wurden nicht entfernt.",
}

   
export default  text
